import React from 'react'

export const PageNotFound = () => {
    return (
        <div>
            <h1>404 Page Not Found. Sorry!</h1>
        </div>
    )
}
